import http from '@/utils/http'

export default {
  // 律师前三名展示数据请求接口
  getPositionLawyerList (params) {
    return http.get('/promotion/v1/api/lawyer/reviewLawyerList?pageIndex=' + params.pageIndex + '&pageSize=' + params.pageSize + '&expertField=' + params.expertField)
  },
  // 获取领域信息
  getFieldDetail (id) {
    return http.get(`/promotion/v1/api/field/${id}`)
  },
  // 获取文章列表
  getArticleList (params) {
    return http.get('/promotion/v1/api/weChatArticle/recommend/provider?pageNo=' + params.pageIndex + '&pageSize=' + params.pageSize +
      '&title=' + params.title + '&type=' + params.type
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/field-detail/api/index.js